import { Component, OnInit } from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {FormBuilder} from "@angular/forms";
import {Router} from "@angular/router";
import {NotifierService} from "angular-notifier";
import {UserService} from "../../../service/user.service";

@Component({
  selector: 'app-resort-booking-accepted',
  templateUrl: './resort-booking-accepted.component.html',
  styleUrls: ['./resort-booking-accepted.component.scss']
})
export class ResortBookingAcceptedComponent implements OnInit {


  bookings:any [];
  listOfData:any [];
  modalRef: BsModalRef;
  requestId: any;
  constructor(private formBuilder: FormBuilder, private route: Router, private notifier: NotifierService,
              private userService: UserService, private modalService: BsModalService,) {
  }

  ngOnInit() {
    this.getAll();
  }



  getAll(){
    this.userService.bookinggetAllActive().subscribe(
      res=>{
        if (res.responseCode === 200) {
          this.bookings =res.data;
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }
}
